import React, { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { apiUrl } from "../config/api";
import { adminAuthHeaders } from "../utils/authHeaders";

const BalanceEditor = () => {
  const [users, setUsers] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    title: "",
    description: "",
    moneyAmount: "",
    goldAmount: "",
  });
  const [message, setMessage] = useState("");

  useEffect(() => {
    fetchUsers();
  }, []);

  const fetchUsers = async () => {
    try {
      const response = await fetch(apiUrl("/api/users"), {
        headers: adminAuthHeaders(),
      });
      const data = await response.json();

      if (data.status === "success") {
        setUsers(data.users);
      } else {
        alert("خطا در دریافت لیست کاربران");
      }
    } catch (error) {
      console.error("Error fetching users:", error);
    }
  };

  const handleEditClick = (user) => {
    setSelectedUser(user);
    setFormData({
      title: "",
      description: "",
      moneyAmount: "",
      goldAmount: "",
    });
    setMessage("");
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedUser(null);
  };

  const handleChange = (e) => {
    setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage("");

    try {
      const response = await fetch(apiUrl(`/api/users/${selectedUser.id}/balance`), {
        method: "PATCH",
        headers: adminAuthHeaders({ "Content-Type": "application/json" }),
        body: JSON.stringify({
          title: formData.title,
          description: formData.description,
          moneyAmount: formData.moneyAmount === "" ? null : parseFloat(formData.moneyAmount),
          goldAmount: formData.goldAmount === "" ? null : parseFloat(formData.goldAmount),
        }),
      });

      const result = await response.json();

      if (response.ok && result.status === "success") {
        setMessage("موجودی با موفقیت بروزرسانی شد.");
        fetchUsers();
        setTimeout(closeModal, 1500);
      } else {
        setMessage(result.error || "خطایی رخ داد.");
      }
    } catch (error) {
      setMessage("خطا در ارتباط با سرور.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="user-manager-container">
      <h2>مدیریت کاربران و موجودی</h2>

      <div className="users-list">
        {users.length === 0 ? (
          <p>در حال بارگذاری...</p>
        ) : (
          <table>
            <thead>
              <tr>
                <th>نام</th>
                <th>نام خانوادگی</th>
                <th>موجودی پول</th>
                <th>موجودی طلا</th>
                <th>عملیات</th>
              </tr>
            </thead>
            <tbody>
              {users.map((user) => (
                <tr key={user.id}>
                  <td>{user.firstName}</td>
                  <td>{user.lastName}</td>
                  <td>{user.moneyBalance} تومان</td>
                  <td>{user.goldBalance} گرم</td>
                  <td>
                    <button className="btn-edit" onClick={() => handleEditClick(user)}>
                      ویرایش موجودی
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>

      {isModalOpen &&
        selectedUser &&
        createPortal(
          <div className="modal-overlay">
            <div className="modal-content">
              <h3>
                ویرایش موجودی: {selectedUser.firstName} {selectedUser.lastName}
              </h3>

              {message && (
                <div className={`message ${message.includes("موفقیت") ? "success" : "error"}`}>
                  {message}
                </div>
              )}

              <form onSubmit={handleSubmit}>
                <div className="form-group1">
                  <label>موضوع تراکنش:</label>
                  <input
                    type="text"
                    name="title"
                    placeholder="مثال: واریز دستی، اصلاح موجودی، تسویه حساب"
                    value={formData.title}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="form-group1">
                  <label>شرح تراکنش:</label>
                  <textarea
                    name="description"
                    placeholder="مثال: واریز حقوق، خرید طلا..."
                    value={formData.description}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="form-group1">
                  <label>تاثیر پولی (تومان):</label>
                  <input
                    type="number"
                    step="0.01"
                    name="moneyAmount"
                    placeholder="مثال: 100000 یا -50000"
                    value={formData.moneyAmount}
                    onChange={handleChange}
                  />
                </div>

                <div className="form-group1">
                  <label>تاثیر طلا (گرم):</label>
                  <input
                    type="number"
                    step="0.01"
                    name="goldAmount"
                    placeholder="مثال: 2.5 یا -0.75"
                    value={formData.goldAmount}
                    onChange={handleChange}
                  />
                </div>

                <div className="modal-actions">
                  <button type="submit" disabled={loading} className="btn-submit">
                    {loading ? "در حال پردازش..." : "ثبت تغییرات"}
                  </button>
                  <button type="button" onClick={closeModal} className="btn-cancel">
                    انصراف
                  </button>
                </div>
              </form>
            </div>
          </div>,
          document.body
        )}
    </div>
  );
};

export default BalanceEditor;
